import React, { useState, useEffect } from "react";
import "./ProspectiveStudent.css";
import BannerSection from "../../Pages/Alumni/Partials/Banner";

const ProspectiveStudentDemo = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };

  const toggleFaq = (id) => {
    setActiveFaq(activeFaq === id ? null : id);
  };

  return (
    <>
      <BannerSection />
      <section className="prospective_section">
        <div className="container">
          <div className="row mb-3">
            <div className="sec-title text-center">
              <h2>Prospective Students</h2>
            </div>
            <p>
              Chettinad Academy of Research and Education (CARE), conferred the
              status of Deemed to be University in 2008, is a premier
              institution for higher education and research in Medicine,
              Nursing, Allied Health Sciences, Pharmacy, Physiotherapy,
              Architecture, Commerce, and Law.
            </p>
            <p>
              Accredited with NAAC 'A' Grade, CARE is approved by MCI, INC,
              TNNMC, AICTE, COA, BCI, PCI, holds UGC 12B status, recognized as
              SIRO by DSIR, and ranked 9th nationally in UI Green Metric
              Rankings.
            </p>
          </div>

          <div className="row d-flex justify-content-center align-items-start mb-3 mb-md-5">
            <div className="col-md-6 col-12">
              <ul className="visitor-col mb-4 mb-md-0">
                <h3 className="mb-3 mt-3 text-center">Academic Excellence</h3>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> Offers 74 academic
                  programs across diverse disciplines.
                </li>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> 2500+ students,
                  including many first-generation learners.
                </li>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> Scholarships up to
                  100% for deserving students.
                </li>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> Placement
                  assistance through dedicated Career Cell.
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-12">
              <ul className="visitor-col bg-light">
                <h3 className="mb-3 mt-3 text-center">Research & Innovation</h3>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> 1100+ publications
                  and 35+ patents.
                </li>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> Advanced research
                  facilities, CPCSEA-approved animal house, and translational
                  research labs.
                </li>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> Active MoUs with
                  global institutions like Linkoping University (Sweden) and
                  Milano Medical Health Aging Unit (Italy).
                </li>
                <li>
                  <i className="fa fa-dot-circle-o me-2"></i> Funded projects
                  from DST, DBT, CSIR, ICMR, RSSDI, and more.
                </li>
              </ul>
            </div>
          </div>

          <div className="sec-title text-center py-3">
            <h2>Student Life & Campus</h2>
          </div>
          <div className="row d-flex justify-content-center align-items-center mb-3 mb-md-5">
            <div className="col-md-8 col-12">
              <ul className="visitor">
                <li>
                  <i className="fa fa-check-circle-o me-2"></i> Wi-Fi enabled
                  green campus with hospital, hostels, auditoria, and modern
                  amenities.
                </li>
                <li>
                  <i className="fa fa-check-circle-o me-2"></i> World-class
                  sports facilities including stadium, swimming pool, football &
                  cricket grounds.
                </li>
                <li>
                  <i className="fa fa-check-circle-o me-2"></i> Annual cultural
                  fest "Fusion Chettinad" and student-led newsletter CARE
                  Konnect.
                </li>
                <li>
                  <i className="fa fa-check-circle-o me-2"></i> Safe and
                  eco-friendly environment with renewable energy and water
                  recycling.
                </li>
              </ul>
            </div>
            <div className="col-md-4 col-12">
              <img
                src="/assets/images/apply-img.jpg"
                alt="Campus application"
                style={{ borderRadius: "10px" }}
                className="mt-3 mt-md-0"
              />
            </div>
          </div>

          <div className="mb-3 mb-md-5">
            <div className="sec-title text-center py-3">
              <h2>Community Outreach</h2>
            </div>
            <p>
              CARE actively supports health initiatives in adopted villages,
              collaborates with government and NGOs, and ensures holistic
              education with emphasis on capability, character, and commitment.
            </p>
            <p>
              With its strong focus on teaching, research, and innovation, CARE
              continues to shape professionals and leaders in healthcare, law,
              and architecture.
            </p>
          </div>

          <div className="sec-title text-center py-3">
            <h2>Program Listing</h2>
          </div>
          <div className="accordion mb-5" id="prospecticeAccordion">
            {/* Chettinad Hospital & Research Institute */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeAccordion === "chri" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleAccordion("chri")}
                >
                  Chettinad Hospital & Research Institute
                </button>
              </h5>
              <div
                id="chri"
                className={`accordion-collapse collapse ${activeAccordion === "chri" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Faculty of Medicine</h4>
                          <p className="text-secondary program-year">
                            (3 years - 4 ½ years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/faculty-of-medicine/about/"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i>{" "}
                            Faculty of Medicine
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Allied Health Sciences</h4>
                          <p className="text-secondary program-year">
                            (3 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="http://182.73.176.178/school/chettinad-allied-health-sciences/about/"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> Allied
                            Health Sciences
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Chettinad College of Nursing */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeAccordion === "Nursing" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleAccordion("Nursing")}
                >
                  Chettinad College of Nursing
                </button>
              </h5>
              <div
                id="Nursing"
                className={`accordion-collapse collapse ${activeAccordion === "Nursing" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Under Graduation</h4>
                          <p className="text-secondary program-year">
                            (Nursing)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-nursing/admissions/#tabver11"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> B.Sc.
                            (Nursing)
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Post Graduation</h4>
                          <p className="text-secondary program-year">
                            (Nursing)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-nursing/admissions/#tabver21"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> M.Sc.
                            (Nursing)
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* School of Architecture */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeAccordion === "Architecture" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleAccordion("Architecture")}
                >
                  School of Architecture
                </button>
              </h5>
              <div
                id="Architecture"
                className={`accordion-collapse collapse ${activeAccordion === "Architecture" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Under Graduation</h4>
                          <p className="text-secondary program-year">
                            (5 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-architecture/admissions/#tabver11"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i>{" "}
                            Bachelors of Architecture (B.Arch)
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* School of Pharmaceutical Sciences */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeAccordion === "Pharmaceutical" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleAccordion("Pharmaceutical")}
                >
                  School of Pharmaceutical Sciences
                </button>
              </h5>
              <div
                id="Pharmaceutical"
                className={`accordion-collapse collapse ${activeAccordion === "Pharmaceutical" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Under Graduation</h4>
                          <p className="text-secondary program-year">
                            (4 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/chettinad-school-of-pharmaceutical-sciences/admission/#tabver11"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> B.
                            Pharm - Bachelor of Pharmacy
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Post Graduate</h4>
                          <p className="text-secondary program-year">
                            (2 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/chettinad-school-of-pharmaceutical-sciences/admission/#tabver21"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i>{" "}
                            M.Pharm (Master of Pharmacy)
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Doctorate</h4>
                          <p className="text-secondary program-year">
                            (6 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/chettinad-school-of-pharmaceutical-sciences/admission/#tabver31"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> Pharm.
                            D (Doctor of Pharmacy)
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Research</h4>
                          <p className="text-secondary program-year">
                            Ph.D Programme
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/chettinad-school-of-pharmaceutical-sciences/admission/#tabver41"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> Ph.D
                            Programme
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* School of Physiotherapy */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeAccordion === "Physiotherapy" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleAccordion("Physiotherapy")}
                >
                  School of Physiotherapy
                </button>
              </h5>
              <div
                id="Physiotherapy"
                className={`accordion-collapse collapse ${activeAccordion === "Physiotherapy" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Under Graduation</h4>
                          <p className="text-secondary program-year">
                            (4 1/2 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-architecture/admissions/#tabver11"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i>{" "}
                            Bachelors of Physiotherapy (B.P.T)
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Post Graduation</h4>
                          <p className="text-secondary program-year">
                            (2 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-physiotherapy/admissions/#tabver21"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i>{" "}
                            Masters of Physiotherapy (M.P.T)
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* School of Law */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeAccordion === "Law" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleAccordion("Law")}
                >
                  School of Law
                </button>
              </h5>
              <div
                id="Law"
                className={`accordion-collapse collapse ${activeAccordion === "Law" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Integrated Degree Program</h4>
                          <p className="text-secondary program-year">
                            (5 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-law/admissions/#tabver11"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i>{" "}
                            BA.LL.B. (Hons.)
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Degree Program</h4>
                          <p className="text-secondary program-year">
                            (3 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-law/admissions/#tabver21"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> LL.B
                            (Hons.)
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* School of Occupational Therapy */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeAccordion === "Occupational" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleAccordion("Occupational")}
                >
                  School of Occupational Therapy
                </button>
              </h5>
              <div
                id="Occupational"
                className={`accordion-collapse collapse ${activeAccordion === "Occupational" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <div className="row">
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Under Graduation</h4>
                          <p className="text-secondary program-year">
                            (4 1/2 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-occupational-therapy/admission/#tabver11"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i>{" "}
                            Bachelor in Occupational Therapy (B.O.T)
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 mb-3 col-12">
                      <div className="program-box-card">
                        <div className="program-box mb-2">
                          <i className="fa fa-user-graduate program-big"></i>
                          <h4 className="mb-2">Post Graduation</h4>
                          <p className="text-secondary program-year">
                            (2 years)
                          </p>
                        </div>
                        <div className="program-box-links">
                          <a
                            href="https://care.edu.in/school/school-of-occupational-therapy/admission/#tabver21"
                            target="_blank"
                          >
                            <i className="fa fa-graduation-cap me-2"></i> MOT in
                            Rehabilitation
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3 mb-md-5">
            <div className="sec-title text-center py-3">
              <h2>
                Admissions – Academic Year 2025–26 (Full-Time Undergraduate
                Programmes)
              </h2>
            </div>
            <p>
              <strong>Prospective students</strong> are invited to apply for
              CARE's full-time undergraduate programmes. Applicants can visit{" "}
              <a href="https://care.edu.in">www.care.edu.in</a> to download the
              prospectus and application forms, which provide details on:
            </p>
            <ul className="visitor">
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Eligibility
                criteria
              </li>
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Fee structure
              </li>
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Scholarships
                available
              </li>
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Academic calendar
              </li>
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Application
                process
              </li>
            </ul>
            <p>
              For certain programmes such as{" "}
              <strong>
                Medicine, Architecture, and Law, national-level entrance exams
              </strong>{" "}
              (NEET, NATA, CLAT, etc.) are mandatory, and admissions are based
              on respective exam scores.
            </p>
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-md-8 col-12">
                <ul className="visitor">
                  <li>
                    <i className="fa fa-check-circle-o me-2"></i>{" "}
                    <strong>The CARE Central Library</strong>, spread over{" "}
                    <strong>32,000 sq. ft.</strong>, is a hub of knowledge with:
                  </li>
                  <li>
                    <i className="fa fa-check-circle-o me-2"></i> Extensive
                    collections of Indian & international books, journals, and
                    magazines
                  </li>
                  <li>
                    <i className="fa fa-check-circle-o me-2"></i>{" "}
                    <strong>Virtual library</strong> with e-books, e-journals,
                    Medlar search, and media resource services
                  </li>
                  <li>
                    <i className="fa fa-check-circle-o me-2"></i>{" "}
                    <strong>Automated Library Management Software</strong> with
                    OPAC (Online Public Access Catalogue) for easy book searches
                  </li>
                  <li>
                    <i className="fa fa-check-circle-o me-2"></i> Dedicated{" "}
                    <strong> departmental libraries </strong>for each school
                  </li>
                </ul>
              </div>
              <div className="col-md-4 col-12">
                <img
                  src="https://caredemo.care.edu.in/assets/images/lib4.webp"
                  alt="Why Learn French"
                  className="img-fluid mb-3 mb-md-0"
                  style={{
                    borderRadius: "10px",
                    height: "200px",
                    width: "100%",
                  }}
                />
              </div>
            </div>
            <p>The library supports CARE's mission to:</p>
            <ul className="visitor">
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Enhance learning
                and research
              </li>
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Promote reading
                habits among staff and students
              </li>
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Provide
                open-access, flexible learning resources
              </li>
              <li>
                <i className="fa fa-check-circle-o me-2"></i> Integrate
                effectively with teaching and learning programmes
              </li>
            </ul>
          </div>

          <div className="mb-3 mb-md-5">
            <div className="sec-title text-center py-3">
              <h2>Accessible Education</h2>
            </div>
            <p>
              At CARE, inclusivity is at the heart of education. Across{" "}
              <strong>Kelambakkam, Manamai, and KGF campuses,</strong> students
              with disabilities and special needs are empowered through
              appropriate support systems. CARE ensures equal access to
              education, opportunities, and participation in all academic and
              extracurricular activities.
            </p>
          </div>

          <div className="sec-title text-center py-3">
            <h2>Services</h2>
          </div>
          <p>
            Students with disabilities and special needs can approach us for
            assistance to access services and support such as:
          </p>
          <ul className="visitor">
            <li>
              <i className="fa fa-check-circle-o me-2"></i> Academic and
              Non-Academic Counselling
            </li>
            <li>
              <i className="fa fa-check-circle-o me-2"></i> Transition Support
            </li>
            <li>
              <i className="fa fa-check-circle-o me-2"></i> Advice on Assistive
              Technology Devices
            </li>
            <li>
              <i className="fa fa-check-circle-o me-2"></i> Access to Facilities
            </li>
          </ul>
          <p>
            Students may be required to undergo assessments to ascertain
            appropriate support services. These assessments may be conducted
            internally at CARE or externally by third-party service providers.
            In such cases, students may need to bear the costs for such
            assessments.
          </p>

          <div className="sec-title text-center py-3">
            <h2>FAQ's</h2>
          </div>
          <div className="accordion mb-5" id="faqAccordion">
            {/* FAQ 1 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "one" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("one")}
                >
                  1. How can I apply for a course at Chettinad Academy of
                  Research and Education?
                </button>
              </h5>
              <div
                id="one"
                className={`accordion-collapse collapse ${activeFaq === "one" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>
                    Applications can be submitted online through the official
                    CARE website. Each program has specific eligibility criteria
                    and admission procedures, which are detailed in the
                    respective program's information bulletin.
                  </p>
                  <ul className="visitor">
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <a
                        href="https://admission.care.edu.in/kelambakkam"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "black", textDecoration: "underline" }}
                      >
                        Kelambakkam Campus
                      </a>
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <a
                        href="https://admission.care.edu.in/manamai"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "black", textDecoration: "underline" }}
                      >
                        Manamai Campus
                      </a>
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <a
                        href="https://admission.care.edu.in/kgf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "black", textDecoration: "underline" }}
                      >
                        KGF Campus
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* FAQ 2 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "two" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("two")}
                >
                  2. How many campuses does Chettinad have, and what courses are
                  offered?
                </button>
              </h5>
              <div
                id="two"
                className={`accordion-collapse collapse ${activeFaq === "two" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>CARE has three campuses :</p>
                  <ul className="visitor">
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <strong>Kelambakkam Campus:</strong> Offers programs in
                      Medicine, Nursing, Allied Health Sciences, Pharmacy,
                      Physiotherapy, Architecture, Law, and Commerce.
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <strong>Manamai Campus: </strong> An extension of the
                      Kelambakkam campus, offering Allied Health sciences,
                      pharmaceutical science, Occupational therapy,
                      physiotherapy and B. Tech programs with state-of-the-art
                      facilities.
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <strong>KGF, Kolar Campus:</strong> Chettinad Academy of
                      Research and Education (CARE) has expanded its academic
                      footprint by establishing a campus in{" "}
                      <strong>Kolar Gold Fields (KGF), Karnataka</strong>. This
                      move aligns with CARE's commitment to providing quality
                      education in healthcare and allied disciplines.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* FAQ 3 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "three" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("three")}
                >
                  3. How can I contact the admissions office for queries?
                </button>
              </h5>
              <div
                id="three"
                className={`accordion-collapse collapse ${activeFaq === "three" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p className="admission-contact d-flex align-items-start mb-3">
                    <span className="icon-circle d-flex align-items-center justify-content-center me-2">
                      <i className="fa fa-map-marker"></i>
                    </span>
                    <span>
                      Chettinad Health City,
                      <br />
                      Rajiv Gandhi Salai,
                      <br />
                      Kelambakkam - 603 103,
                      <br />
                      Chengalpattu District, Chennai,
                      <br />
                      Tamil Nadu, India.
                    </span>
                  </p>
                  <p className="admission-contact mb-3">
                    <strong
                      className="d-block mb-2 fs-6"
                      style={{ color: "var(--thm-bg)" }}
                    >
                      For Admissions & Enquiry:
                    </strong>
                    <a
                      href="tel:+918447892022"
                      className="contact-phone d-flex align-items-center"
                    >
                      <span className="icon-circle d-flex align-items-center justify-content-center me-2">
                        <i className="fa fa-phone"></i>
                      </span>
                      <span className="phone-number">+91 84478 92022</span>
                    </a>
                  </p>
                  <a
                    href="https://care.edu.in/contact/care/"
                    style={{ color: "black", textDecoration: "underline" }}
                  >
                    Click here
                  </a>
                </div>
              </div>
            </div>

            {/* FAQ 4 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "four" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("four")}
                >
                  4. Are scholarships available for students? If so, what is the
                  procedure?
                </button>
              </h5>
              <div
                id="four"
                className={`accordion-collapse collapse ${activeFaq === "four" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>
                    Yes, CARE offers merit-based scholarships up to 100% for
                    deserving students for Allied Health sciences,
                    Pharmaceutical sciences, physiotherapy, occupational
                    therapy, B.Tech ,law and Architecture.
                  </p>
                  <p className="admission-contact">
                    <strong
                      className="d-block mb-2 fs-6"
                      style={{ color: "var(--thm-bg)" }}
                    >
                      Contact the admissions team for further details
                    </strong>
                    <a
                      href="tel:+918447892022"
                      className="contact-phone d-flex align-items-center"
                    >
                      <span className="icon-circle d-flex align-items-center justify-content-center me-2">
                        <i className="fa fa-phone"></i>
                      </span>
                      <span className="phone-number">+91 84478 92022</span>
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* FAQ 5 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "five" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("five")}
                >
                  5. What are the payment procedures?
                </button>
              </h5>
              <div
                id="five"
                className={`accordion-collapse collapse ${activeFaq === "five" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>
                    Students can make fee payments online through the CARE
                    website or DD (demand draft) under respective school name.
                    Other mode of payments are not accepted. The "Online Fees
                    Payment" section provides detailed instructions and links
                    for secure transactions.
                  </p>
                  <p>
                    <strong>Payment link:</strong>
                  </p>
                  <ul className="visitor">
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <a
                        href="https://admission.care.edu.in/kelambakkam"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "black", textDecoration: "underline" }}
                      >
                        Kelambakkam Campus
                      </a>
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <a
                        href="https://admission.care.edu.in/manamai"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "black", textDecoration: "underline" }}
                      >
                        Manamai Campus
                      </a>
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>
                      <a
                        href="https://admission.care.edu.in/kgf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "black", textDecoration: "underline" }}
                      >
                        KGF Campus
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* FAQ 6 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "six" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("six")}
                >
                  6. What campus facilities are available?
                </button>
              </h5>
              <div
                id="six"
                className={`accordion-collapse collapse ${activeFaq === "six" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>CARE provides a range of facilities, including:</p>
                  <ul className="visitor">
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>{" "}
                      State-of-the-art lecture halls and laboratories
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i>{" "}
                      Wi-Fi-enabled campus
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i> Hostel
                      accommodations
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i> Food courts
                      and cafes
                    </li>
                    <li>
                      <i className="fa fa-check-circle-o me-2"></i> Sports
                      facilities and gymnasium
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* FAQ 7 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "seven" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("seven")}
                >
                  7. Does Chettinad offer internship and placement support?
                </button>
              </h5>
              <div
                id="seven"
                className={`accordion-collapse collapse ${activeFaq === "seven" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>
                    Yes, CARE has a dedicated Career Development Cell that
                    provides internship and placement support to students,
                    helping them transition from academics to professional
                    careers.
                  </p>
                </div>
              </div>
            </div>

            {/* FAQ 8 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "eight" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("eight")}
                >
                  8. Is there any provision for international students?
                </button>
              </h5>
              <div
                id="eight"
                className={`accordion-collapse collapse ${activeFaq === "eight" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>
                    CARE welcomes international students and provides necessary
                    support, including guidance on admission procedures, visa
                    requirements, and accommodation. The International Students
                    Cell assists in facilitating a smooth transition for
                    international students.
                  </p>
                </div>
              </div>
            </div>

            {/* FAQ 9 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "nine" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("nine")}
                >
                  9. How does CARE promote research and innovation?
                </button>
              </h5>
              <div
                id="nine"
                className={`accordion-collapse collapse ${activeFaq === "nine" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>
                    CARE fosters a culture of research and innovation through
                    its Institution's Innovation Council (IIC). The council
                    encourages students and faculty to engage in innovative
                    projects that address community and individual challenges.
                  </p>
                  <a href="https://care.edu.in/iic/">click here</a>
                </div>
              </div>
            </div>

            {/* FAQ 10 */}
            <div className="accordion-item">
              <h5 className="accordion-header">
                <button
                  className={`accordion-button ${activeFaq === "ten" ? "" : "collapsed"}`}
                  type="button"
                  onClick={() => toggleFaq("ten")}
                >
                  10. What are the hostel facilities like?
                </button>
              </h5>
              <div
                id="ten"
                className={`accordion-collapse collapse ${activeFaq === "ten" ? "show" : ""}`}
              >
                <div className="accordion-body">
                  <p>
                    The hostels at CARE offer both air-conditioned and
                    non-air-conditioned single and shared rooms. Facilities
                    include uninterrupted water and power supply, gymnasium,
                    sports amenities, laundromats, and Wi-Fi services. The
                    hostel mess provides hygienic multi-cuisine meals to suit
                    diverse tastes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProspectiveStudentDemo;
